import React from 'react';
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import { uk } from "date-fns/locale";
import i18next from "../../i18n.js";

registerLocale("uk", uk);

const InputControl = React.forwardRef((props, ref) => (
    <div className='date-input-control' disabled={props.disabled} onClick={props.onClick} ref={ref}>{props.value}</div>
));
export class DateTimeInput extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleClear = this.handleClear.bind(this);
    }
    handleChange(date) {
        if (this.props.onChange) {
            const e = {
                target: {
                    value: date ? moment(date).format("YYYY-MM-DD") : '',
                    name: this.props.name
                }
            }
            this.props.onChange(e);
        }
    }
    handleClear() {
        if (this.props.onChange) {
            const e = {
                target: {
                    value: '',
                    name: this.props.name
                }
            }
            this.props.onChange(e);
        }
    }
    render() {
        const { value, min, max, disabled } = this.props;
        return (
            <div className="date-input-contaner" name={this.props.name} >
                <DatePicker
                    selected={value ? new Date(value) : null}
                    locale="uk"
                    dateFormat="dd.MM.yyyy"
                    minDate={min ? new Date(min) : null}
                    maxDate={max ? new Date(max) : null}
                    disabled={disabled}
                    portalId="root-portal"
                    popperClassName="date-input-popper"
                    customInput={<InputControl className='date-input-control' />}
                    onChange={(date) => this.handleChange(date)}>
                    <div style={{ color: "#216ba5" }} onClick={this.handleClear} >{i18next.t('other.clear')}</div>
                </DatePicker>
            </div>
        );
    }
}